import React from "react";
import { Button } from "semantic-ui-react";
import useConveyorBoxHandlers from "../../../hooks/useConveyorBoxHandlers";

type Props = {};

const PartialDeliveryButton = (props: Props) => {
  const { onOpenPartialDeliveryModalHandler } = useConveyorBoxHandlers();
  return (
    <Button
      content="Delleverans"
      size="big"
      aria-label="Delleverera"
      icon="cut"
      onClick={onOpenPartialDeliveryModalHandler}
      disabled={false}
    />
  );
};

export default PartialDeliveryButton;
